/* ==========================================================================
   SALE TOP PICKS 首页「加载更多」（原地追加商品）
   原理：点击按钮 → fetch 轻量备用模板 /collections/<handle>?view=card-feed&page=N
        → 解析其中的 <li> 商品卡 → 追加到本板块的列表 → 读 data-has-next 决定是否还有下一页
   不依赖 Shopify 首页 paginate（首页 paginate 不产生 next），故自行翻页。
   ========================================================================== */
(function () {
  'use strict';

  function bind(btn) {
    if (btn.dataset.bound) return;
    btn.dataset.bound = '1';

    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-loading')) return;

      var list = document.getElementById(btn.dataset.targetId);
      var feedUrl = btn.dataset.feedUrl;
      var page = parseInt(btn.dataset.next || '2', 10);
      var wrap = btn.closest('[data-sale-loadmore-wrap]');
      if (!list || !feedUrl) return;

      btn.classList.add('is-loading');
      var sep = feedUrl.indexOf('?') > -1 ? '&' : '?';

      fetch(feedUrl + sep + 'page=' + page, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var feed = doc.querySelector('.card-feed-list');
          if (!feed) {
            if (wrap) wrap.remove();
            return;
          }
          var frag = document.createDocumentFragment();
          while (feed.children.length) {
            frag.appendChild(feed.children[0]);
          }
          list.appendChild(frag);

          // 追加后重新挂载图片懒加载/提示
          if (window.webvista && typeof window.webvista.initLazyImages === 'function') {
            window.webvista.initLazyImages();
          }
          if (window.webvista && typeof window.webvista.initTooltips === 'function') {
            window.webvista.initTooltips();
          }

          // 追加后给新卡片补上"产品图/佩戴图"切换小点点（复用前端的初始化）
          if (typeof window.svReinitCardImageSwitch === 'function') {
            setTimeout(window.svReinitCardImageSwitch, 60);
          }

          btn.dataset.next = String(page + 1);
          if (feed.getAttribute('data-has-next') !== 'true') {
            if (wrap) wrap.remove(); // 没有下一页了，移除按钮
          }
        })
        .catch(function (e) {
          console.error('[sale-top-picks] 加载更多失败', e);
        })
        .finally(function () {
          btn.classList.remove('is-loading');
        });
    });
  }

  function init() {
    var btns = document.querySelectorAll('[data-sale-loadmore]');
    for (var i = 0; i < btns.length; i++) bind(btns[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function initMobileProductImageSwitch() {
    if (!isMobile()) return;

    const cards = document.querySelectorAll(
      '.slider-slide .product-card-wrapper'
    );

    cards.forEach(function (cardWrapper) {
      const media = cardWrapper.querySelector('.card-media');
      const cardInner = cardWrapper.querySelector('.card-inner');

      if (!media || !cardInner) return;

      const images = media.querySelectorAll(
        'img.product-card-featured-image, img.product-card-secondary-image'
      );

      if (images.length < 2) return;

      if (cardWrapper.dataset.mobileImageSwitch === 'true') return;
      cardWrapper.dataset.mobileImageSwitch = 'true';

      /* 清理旧版本生成的圆点 */
      cardWrapper.querySelectorAll('.mobile-card-image-dots').forEach(function (oldDots) {
        oldDots.remove();
      });

      let currentIndex = 0;
      let startX = 0;
      let startY = 0;
      let moveX = 0;
      let isHorizontalSwipe = false;
      let isSwiping = false;

      const dots = document.createElement('div');
      dots.className = 'mobile-card-image-dots';

      function switchImage(index) {
        if (index < 0) {
          index = images.length - 1;
        }

        if (index >= images.length) {
          index = 0;
        }

        currentIndex = index;

        images.forEach(function (img, imgIndex) {
          img.classList.toggle('is-mobile-active', imgIndex === currentIndex);
        });

        dots.querySelectorAll('.mobile-card-image-dot').forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === currentIndex);
        });
      }

      images.forEach(function (img, index) {
        img.classList.toggle('is-mobile-active', index === 0);

        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mobile-card-image-dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', '切换商品图片 ' + (index + 1));

        dot.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          switchImage(index);
        });

        dots.appendChild(dot);
      });

      /*
        圆点插入到图片区域后面、标题前面
        结构变成：
        .card-inner 图片区域
        .mobile-card-image-dots 圆点
        .card-content 标题价格
      */
      cardInner.insertAdjacentElement('afterend', dots);

      /*
        绑定到 cardInner，而不是 card-media
        因为商品图上方可能有 a 链接遮罩层
      */
      cardInner.addEventListener(
        'touchstart',
        function (event) {
          if (!isMobile()) return;

          const touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          moveX = 0;
          isHorizontalSwipe = false;
          isSwiping = false;
        },
        {
          passive: true,
          capture: true
        }
      );

      cardInner.addEventListener(
        'touchmove',
        function (event) {
          if (!isMobile()) return;

          const touch = event.touches[0];
          const diffX = touch.clientX - startX;
          const diffY = touch.clientY - startY;

          moveX = diffX;

          /*
            横向滑动时：
            1. 当前商品图切换
            2. 阻止外层 slider 跟着滑
          */
          if (Math.abs(diffX) > 10 && Math.abs(diffX) > Math.abs(diffY)) {
            isHorizontalSwipe = true;
            isSwiping = true;

            event.preventDefault();
            event.stopPropagation();
          }
        },
        {
          passive: false,
          capture: true
        }
      );

      cardInner.addEventListener(
        'touchend',
        function (event) {
          if (!isMobile()) return;

          if (!isHorizontalSwipe) return;
          if (Math.abs(moveX) < 35) return;

          event.preventDefault();
          event.stopPropagation();

          if (moveX < 0) {
            switchImage(currentIndex + 1);
          } else {
            switchImage(currentIndex - 1);
          }

          /*
            防止滑动后误触商品详情链接
          */
          setTimeout(function () {
            isSwiping = false;
            isHorizontalSwipe = false;
            moveX = 0;
          }, 150);
        },
        {
          passive: false,
          capture: true
        }
      );

      /*
        防止拖拽切换后误点进商品详情页
      */
      cardInner.addEventListener(
        'click',
        function (event) {
          if (!isMobile()) return;

          if (isSwiping || Math.abs(moveX) >= 35) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        {
          capture: true
        }
      );
    });
  }

  document.addEventListener('DOMContentLoaded', initMobileProductImageSwitch);
  document.addEventListener('shopify:section:load', initMobileProductImageSwitch);
  /* 暴露给「加载更多」调用，使新追加的卡片也补上产品图/佩戴图切换小点点 */
  window.svReinitCardImageSwitch = initMobileProductImageSwitch;

  setTimeout(initMobileProductImageSwitch, 500);
  setTimeout(initMobileProductImageSwitch, 1500);
  setTimeout(initMobileProductImageSwitch, 3000);
})();
